import { ApolloClient, InMemoryCache } from "@apollo/client";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { onError } from "@apollo/client/link/error";

const errorLink = onError(({ networkError }) => {
  if (!networkError) return;

  if (
    "statusCode" in networkError &&
    [500, 502].includes(networkError.statusCode)
  ) {
    window.location.href = `/500?from=${encodeURIComponent(window.location.href)}`;
  }

  if (
    "statusCode" in networkError &&
    [401, 403].includes(networkError.statusCode) &&
    networkError.statusCode !== 502
  ) {
    // some handling for unauthorized access can be added here
    // window.location.href = `${import.meta.env.VITE_APP_ME_POS_URL}/login`;
  }
});

const uploadLink = createUploadLink({
  uri: import.meta.env.VITE_APP_ME_POS_URL + "/graphql/menu",
  credentials: "include",
});

export const apolloClient = new ApolloClient({
  link: errorLink.concat(uploadLink),
  cache: new InMemoryCache(),
});
